<template>
<div class="chapter">
<div class="inner_page">
<p class="centera"><a id="fm01"></a><a id="page_ii"></a>Also by Sanyika Shakur<br/><em>Monster: The Autobiography of an L.A. Gang Member</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?6d8e0fd2